import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import {
  Modal,
  Table,
  Button,
  Input,
  Form,
  Col,
  Layout,
  Select,
  Space,
  Tag,
  Radio,
  Row,
  Checkbox
} from "antd";
import { useDispatch } from "react-redux";
import { authAction } from "hooks/actions/mainAction";
import {
  LeftOutlined,
  RightOutlined,
  CheckOutlined,
  CloseOutlined,
  CopyTwoTone,
  PlusOutlined,
  DeleteFilled,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import newDateTime from "controllers/newDateTime";

const backend = process.env.REACT_APP_BACKEND;
const StyledTable = styled((props) => <Table {...props} />)`
  && .selectedRow > td {
    background: paleturquoise;
  }
  && .selectedRow:hover > td {
    background: paleturquoise;
  }
  && tbody > tr:hover > td {
    background: azure;
  }
`;

function Word() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sourceDataKor, setSourceDataKor] = useState([]);
  const [rowIndex, setRowIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reRender, setReRender] = useState(false);
  const [rightBoxRerender, setRightBoxRerender] = useState(false)
  const [languageList, setLanguageList] = useState([]);
  const [curLanguage, setCurLanguage] = useState("한국어");
  const [fixLanguage, setFixLanguage] = useState(false);
  const [POSList, setPOSList] = useState([])
  const [wordData, setWordData] = useState([])
  const [originWordData, setOriginWordData] = useState([])
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const [rightBox, setRightBox] = useState([false, {}]);
  const [rightBoxPreNext, setRightBoxPreNext] = useState([false, false]);
  const [preNext, setPreNext] = useState([false, false]);
  const [editPopup, setEditPopup] = useState([false, {}]);
  const [insertPopup, setInsertPopup] = useState(false);

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1, // 현재 표시할 페이지
      pageSizeOptions: [10, 50, 100, 200],
      showSizeChanger: true, // pageSize변경옵션을 표시할지 여부
      pageSize: 10, // 한 페이지에 표시할 레코드 수
      showQuickJumper: true, // page 점프
      hideOnSinglePage: false, //pagenation 자체를 사용하고 싶지 않은 경우 pageSize를 최고로 높이면 됨
    },
    filters: {
      cefrLevel: "all",
      search: "",
      language: "L0010"
    },
  });

  const [wordTableParams, setWordTableParams] = useState({})

  const formRef = useRef(null);
  const rightFormRef = useRef(null);

  const columns = [
    {
      title: "NO",
      dataIndex: "rowKey",
      key: "rowKey",
      width: "100px",
      // sorter: (a,b)=>a.rowKey-b.rowKey
    },
    {
      title: "단어",
      dataIndex: "word",
      key: "word",
      width: "120px",
      sorter: (a,b)=>a.word-b.word,
    },
    {
      title: "CEFR Level",
      dataIndex: "cefr",
      key: "cefr",
      width: "160px",
      sorter: (a,b)=>a.cefr-b.cefr
    },
    {
      title: "의미 갯수("+curLanguage+")",
      dataIndex: "meaningCount",
      key: "meaningCount",
      width: "100px",
      sorter: (a,b)=>a.rowKey-b.rowKey,
    },
    {
      title: "파생어",
      dataIndex: "derivative",
      key: "derivative",
      width: "300px",
    },
    {
      title: "처리",
      dataIndex: "",
      width:"150px",
      render: (_, record) => (
        <div>
          <a
            style={{ margin: "0px 5px" }}
            onClick={(e) => {
              e.stopPropagation();
              const rowIdx = record.num;
              const maxNum = tableParams.pagination.total - 1;
              const plusNum =
                (tableParams.pagination.current - 1) *
                tableParams.pagination.pageSize;
              const idx = plusNum + rowIdx;

              if (
                sourceDataKor.length === 1 &&
                tableParams.pagination.total === 1
              ) {
                setPreNext([true, true]);
              } else if (idx === 0) {
                setPreNext([true, false]);
              } else if (idx === maxNum) {
                setPreNext([false, true]);
              } else {
                setPreNext([false, false]);
              }
              setRightBox([false,{}])
              setRowIndex(rowIdx);
              // console.log(editPopup)
              setEditPopup([true, record]);
            }}
          >
            수정
          </a>
          <a
            style={{ margin: "0px 5px" }}
            onClick={(e) => {
              e.stopPropagation();
              deleteHandler(_);
            }}
          >
            삭제
          </a>
        </div>
      ),
    },
    {}
  ];

  const wordColumns = [
    Table.SELECTION_COLUMN,
    {
      title: "의미",
      dataIndex: "word_meaning",
      key: "word_meaning",
      width: "200px",
      render: (_,record) => (
        <Input 
          value={_}
          onChange={(e)=>{
            const newText = e.target.value;
            const instance = JSON.parse(JSON.stringify(wordData))
            instance[record.num].word_meaning = newText
            setWordData(instance)
          }}
        ></Input>
      )
    },
    {
      title: "품사",
      dataIndex: "ContentSettingPartsOfSpeechMaster_code",
      key: "ContentSettingPartsOfSpeechMaster_code",
      width: "100px",
      render: (_,record) => (
        <Select
          value={_}
          options={POSList}
          onChange={(value)=>{
            const instance = JSON.parse(JSON.stringify(wordData))
            instance[record.num].ContentSettingPartsOfSpeechMaster_code = value
            setWordData(instance)
          }}
        ></Select>
      )
    },
    {
      title: "CEFR Level",
      dataIndex: "cefr",
      key: "cefr",
      width: "100px",
      sorter: (a,b)=>a.cefr-b.cefr,
      render: (_,record) => (
        <Select
          value={_}
          options={[
            {label:"A0", value:"A0"},
            {label:"A1", value:"A1"},
            {label:"A2", value:"A2"},
            {label:"B1", value:"B1"},
            {label:"B2", value:"B2"},
            {label:"C1", value:"C1"},
            {label:"C2", value:"C2"},
          ]}
          onChange={(value)=>{
            const instance = JSON.parse(JSON.stringify(wordData))
            instance[record.num].cefr = value
            setWordData(instance)
          }}
        ></Select>
      )
    },
    {
      title: "처리",
      dataIndex: "",
      width: "100px",
      render: (_, record) => (
        <div>
          <a
            style={{ margin: "0px 5px" }}
            onClick={(e) => {
              e.stopPropagation();
              const nowNum = record.num
              const instance = JSON.parse(JSON.stringify(wordData))
              let deleteNum = 0
              for(let i=0; i<instance.length; i++) {
                if(instance[i].num === nowNum) {
                  deleteNum = i
                  break;
                }
              }
              instance.splice(deleteNum,1)

              const source = instance.map((el,idx)=>{
                el.num = idx
                return el
              })
              setWordData(source)
            }}
          >
            삭제
          </a>
        </div>
      ),
    },
 
  ]

  const getSourceData = (data) => {
    // console.log(data)
    const total = data.data.data[1][0]["FOUND_ROWS()"];
    const page = tableParams.pagination.current
    const size = tableParams.pagination.pageSize
    const plusNum = (page-1) * size
    const sourceData = data.data.data[0].map((el,idx)=>{
        // const nameArray = el.ContentSettingErrorTypeMaster_code.split(",").map(el=>{
        //   for(let i=0; i<data.data.data[2].length;i++) {
        //     if(data.data.data[2][i].code === el) {
        //       return data.data.data[2][i].name
        //     }
        //   }
        // })
        
        const rowKey = total - idx -plusNum;
        // el.name = nameArray
        // el.create_datetime = newDateTime(el.create_datetime)
        el.rowKey = rowKey
        el.num = idx
        return el
    })

    setSourceDataKor(sourceData);
    setLanguageList(data.data.data[2])
    if(editPopup[0] && (rowIndex === 0 || rowIndex === size-1)) {
      setEditPopup([true,sourceData[rowIndex]])
      formRef.current.setFieldsValue(sourceData[rowIndex])
    }
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        total: total, //전체 레코드 수(페이지 숫자 표시를 위해 필요)
      },
    });
    if(rightBox[0]) {
        setRightBox([true,sourceData[rowIndex]])
        rightFormRef.current.setFieldsValue(sourceData[rowIndex])
    }
  };

  const getWordData = (data) => {

    const source = data.data.data[0].map((el,idx)=>{
      el.num = idx
      return el
    })
    setWordData(source)
    setOriginWordData(source)
    setPOSList(data.data.data[1])
  }

  const statusFilter = (value) => {
    // console.log(value)
    setRowIndex(null);
    setRightBox([false, {}]);
    setTableParams({
        ...tableParams,
        pagination:{...tableParams.pagination, current:1},
        filters:{
            ...tableParams.filters,
            status: value
        }
    })
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
        ...tableParams,
        pagination,
        sorter
      });
      if (pagination.pageSize !== tableParams.pagination?.pageSize) {
        setSourceDataKor([]);
      }
      setRightBox([false,{}])
      setRowIndex(null)
  };

  const handleWordTableChange = (pagination, filters, sorter) => {
    setWordTableParams({
      ...wordTableParams,
      sorter
    })
  }
  // const copyToClipboard = () => { // https에서만 지원함
  //   const text = document.querySelector("#sentence").value
  //   window.navigator.clipboard.writeText(text)
  // }
  const copyToClipboard = () => {
      const text = document.querySelector("#sentence").value
      const tempElem = document.createElement('textarea');
      tempElem.value = text;  
      document.body.appendChild(tempElem);
    
      tempElem.select();
      document.execCommand("copy");
      document.body.removeChild(tempElem);
  }

  const insertOkHandler = async () => {
    const value = await formRef.current.validateFields();

    axios
      .put(`${backend}/contents/word`, { value })
      .then((data) => {
        setReRender(!reRender);

        Modal.success({
          title: "등록 완료",
          okText: "확인",
          content: "정상적으로 등록되었습니다.",
          afterClose: () => {
            setInsertPopup(false);
          },
        });
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/auth");
        } else if (err.response.status === 409) {
          Modal.error({
            title: "등록 실패",
            style: { whiteSpace: "pre-line" },
            okText: "확인",
            content:err.response.data.message ||
              "정상적으로 등록되지 않았습니다. \n다시 시도하거나 관리자에게 문의해주세요.",
          });
        } else {
          console.log(err);
          Modal.error({
            title: "등록 실패",
            style: { whiteSpace: "pre-line" },
            okText: "확인",
            content:err.response.data.message ||
              "정상적으로 등록되지 않았습니다. \n다시 시도하거나 관리자에게 문의해주세요.",
          });
        }
      });
  };

  const insertOkNextHandler = async () => {
    const value = await formRef.current.validateFields();

    axios
      .put(`${backend}/contents/word`, { value })
      .then((data) => {
        formRef.current.resetFields()
        setReRender(!reRender);
        // console.log(data)
        // Modal.success({
        //   title: "등록 완료",
        //   okText: "확인",
        //   content: "정상적으로 등록되었습니다.",
        //   afterClose: () => {
        //     setInsertPopup(false);
        //   },
        // });
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/auth");
        } else if (err.response.status === 409) {
          Modal.error({
            title: "등록 실패",
            style: { whiteSpace: "pre-line" },
            okText: "확인",
            content:err.response.data.message ||
              "정상적으로 등록되지 않았습니다. \n다시 시도하거나 관리자에게 문의해주세요.",
          });
        } else {
          console.log(err);
          Modal.error({
            title: "등록 실패",
            style: { whiteSpace: "pre-line" },
            okText: "확인",
            content:err.response.data.message ||
              "정상적으로 등록되지 않았습니다. \n다시 시도하거나 관리자에게 문의해주세요.",
          });
        }
      });
  };

  const editOkHandler = async () => {
    const value = await formRef.current.validateFields();
  
    axios
      .post(`${backend}/contents/word/${value.id}`, { value })
      .then((data) => {
        setReRender(!reRender)
        Modal.success({
          title: "수정 완료",
          okText: "확인",
          content: "정상적으로 수정되었습니다.",
          afterClose:()=>{setEditPopup([false,{}])}
        });
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/auth");
        } else if (err.response.status === 409) {
          Modal.error({
            title: "등록 실패",
            style: { whiteSpace: "pre-line" },
            okText: "확인",
            content:err.response.data.message ||
              "정상적으로 등록되지 않았습니다. \n다시 시도하거나 관리자에게 문의해주세요.",
          });
        } else {
          console.log(err);
          Modal.error({
            title: "등록 실패",
            style: { whiteSpace: "pre-line" },
            okText: "확인",
            content:err.response.data.message ||
              "정상적으로 등록되지 않았습니다. \n다시 시도하거나 관리자에게 문의해주세요.",
          });
        }
      });
  };

  const preRecord = () => {
    const data = sourceDataKor;
    const nowNum =
      rowIndex +
      (tableParams.pagination.current - 1) * tableParams.pagination.pageSize;
    const max = tableParams.pagination.total - 1;
    const preNum = nowNum - 1;
    const newPage = parseInt(preNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === max && preNum !== 0) {
      setPreNext([false, false]);
    }
    if (preNum === 0) {
      setPreNext([true, false]);
    }
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(preNum - plusNum);
    // console.log(rowIndex)
    // console.log(preNum,plusNum)
    if (rowIndex === 0) {
      formRef.current.setFieldValue("num", preNum - plusNum);
    } else {
      setEditPopup([true, data[preNum - plusNum]]);
      formRef.current.resetFields();
      formRef.current.setFieldsValue(data[preNum - plusNum]);
    }

  }

  const nextRecord = () => {
    const data = sourceDataKor;
    const nowNum =
      rowIndex +
      (tableParams.pagination.current - 1) * tableParams.pagination.pageSize;
    const max = tableParams.pagination.total - 1;
    const nextNum = nowNum + 1;
    const newPage = parseInt(nextNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === 0 && nextNum !== max) {
      setPreNext([false, false]);
    }
    if (nextNum === max) {
      setPreNext([false, true]);
    }
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(nextNum - plusNum);
    if (nextNum - plusNum === 0) {
      formRef.current.setFieldValue("num", nextNum - plusNum);
    } else {
      setEditPopup([true, data[nextNum - plusNum]]);
      formRef.current.resetFields();
      formRef.current.setFieldsValue(data[nextNum - plusNum]);
    }
  }

  const deleteHandler = (_) => {
    const {id, meaningCount} = _

    const onOk = () => {
      axios
        .delete(`${backend}/contents/word/${id}`)
        .then(res=>{
          setReRender(!reRender)
          Modal.success({
            title: "삭제 완료",
            okText: "확인",
            content: "정상적으로 삭제되었습니다.",
          });
        })
        .catch(err=>{
          console.log(err)
          Modal.error({
            title: "수정 실피",
            okText: "확인",
            content:
              "정상적으로 삭제되지 않았습니다. 다시 시도하거나 관리자에게 문의해주세요.",
          });
        })
    }
    if (meaningCount === 0) {
      Modal.confirm({
        style: { whiteSpace: "pre-line" },
        title: "경고",
        content:
        "정말로 삭제하시겠습니까?",
        okText: "확인",
        cancelText: "취소",
        onOk: onOk,
      });
    } else {
      Modal.confirm({
        style: { whiteSpace: "pre-line" },
        title: "경고",
        content:
        "선택한 단어에 여러가지 의미가 등록되어 있습니다. \n단어를 삭제할 경우 모두 삭제됩니다.",
        okText: "확인",
        cancelText: "취소",
        onOk: onOk,
      });
    }
  };

  const onRow = (record, rowIdx) => {
    return {
      onClick: () => {
        const data = sourceDataKor;
        const maxNum = tableParams.pagination.total - 1;
        const plusNum =
          (tableParams.pagination.current - 1) *
          tableParams.pagination.pageSize;
        const idx = plusNum + rowIdx;

        if (data.length === 1 && tableParams.pagination.current === 1) {
          setRightBoxPreNext([true, true]);
        } else if (idx === 0) {
          setRightBoxPreNext([true, false]);
        } else if (idx === maxNum) {
          setRightBoxPreNext([false, true]);
        } else {
          setRightBoxPreNext([false, false]);
        }
        setRowIndex(rowIdx);
        // setCurLanguage(data[idx].SystemSettingLanguage_code);
        setRightBox([true, data[rowIdx]]);
        if (rightBox[0]) {
          rightFormRef.current.setFieldsValue(data[rowIdx]);
        }
      },
    };
  };

  const onSearch = (value) => {
    setTableParams({
      ...tableParams,
      pagination:{
        ...tableParams.pagination,
        current:1
      },
      filters: {
        ...tableParams.filters,
        search: value
      }
    })
    setRightBox([false,{}])
    setRightBoxPreNext([false, false]);
    setRowIndex(null);
  }

  const cefrFilter = (value) => {
    setTableParams({
      ...tableParams,
      pagination:{
        ...tableParams.pagination,
        current:1
      },
      filters: {
        ...tableParams.filters,
        cefrLevel: value
      }
    })
    setRightBox([false,{}])
    setRightBoxPreNext([false, false]);
    setRowIndex(null);
  }

  const languageFilter = (value,_) => {
    setTableParams({
      ...tableParams,
      pagination:{
        ...tableParams.pagination,
        current:1
      },
      filters: {
        ...tableParams.filters,
        language: value
      }
    })
    setCurLanguage(_.label)
    setRightBox([false,{}])
    setRightBoxPreNext([false, false]);
    setRowIndex(null);
  }

  const resetValueRight = () => {
    setWordData(originWordData)
    setLoading(false)
  };

  const editOkHandlerRight = async () => {
    let deleteMeaning = []
    let updateMeaning = []

    wordData.forEach(el=>{
      if(el.id<0) {
        updateMeaning.push(el)
      }
    })
    originWordData.forEach(el=>{
      setLoading(true)
      let deleteRow = true
      for(let i=0; i<wordData.length; i++) {
        if(wordData[i].id === el.id) {
          deleteRow = false
          if(
              wordData[i].ContentSettingPartsOfSpeechMaster_code !== el.ContentSettingPartsOfSpeechMaster_code ||
              wordData[i].cefr !== el.cefr ||
              wordData[i].word_meaning !== el.word_meaning
            ) {
              updateMeaning.push(wordData[i])
              break;
            }
          break;
        }
      }
      if(deleteRow) {
        deleteMeaning.push(el.id)
      }
    })

    axios
    .post(`${backend}/contents/word/meaning`,{updateMeaning, deleteMeaning})
    .then(res=>{
      setRightBoxRerender(!rightBoxRerender)
      setReRender(!reRender)
      setLoading(false)
    })
    .catch(err=>{
      console.log(err)
      setLoading(false)
      Modal.error({
        title: "에러",
        okText: "확인",
        content: "서버에러가 발생하여 정상적으로 변경하지 못했습니다.",
        afterClose: () => {
          resetValueRight()
        },
      });
    })
  };

  const editCancelHandlerRight = () => {
    setRightBox([false, {}]);
    setRightBoxPreNext([false, false]);
    setRowIndex(null);
  };

  // // 이전 버튼 클릭 시 작동 함수
  const preRecordRight = () => {
    const data = sourceDataKor;
    const nowNum =
      rowIndex +
      (tableParams.pagination.current - 1) * tableParams.pagination.pageSize;
    const max = tableParams.pagination.total - 1;
    const preNum = nowNum - 1;
    const newPage = parseInt(preNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === max && preNum !== 0) {
      setRightBoxPreNext([false, false]);
    }
    if (preNum === 0) {
      setRightBoxPreNext([true, false]);
    }
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(preNum - plusNum);
    // setCurLanguage(data[preNum].SystemSettingLanguage_code);

    if (rightBox[0]) {
      if (rowIndex === 0) {
        rightFormRef.current.setFieldValue("num", preNum - plusNum);
      } else {
        setRightBox([true, data[preNum - plusNum]]);
        rightFormRef.current.resetFields();
        rightFormRef.current.setFieldsValue(data[preNum - plusNum]);
      }
    }
  };

  // 다음 버튼 클릭 시 작동 함수
  const nextRecordRight = () => {
    const data = sourceDataKor;
    const nowNum =
      rowIndex +
      (tableParams.pagination.current - 1) * tableParams.pagination.pageSize;
    const max = tableParams.pagination.total - 1;
    const nextNum = nowNum + 1;
    const newPage = parseInt(nextNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === 0 && nextNum !== max) {
      setRightBoxPreNext([false, false]);
    }
    if (nextNum === max) {
      setRightBoxPreNext([false, true]);
    }
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(nextNum - plusNum);

    if (rightBox[0]) {
      if (nextNum - plusNum === 0) { //마지막 번호라서 다음 페이지로 넘어가야 할 때
        rightFormRef.current.setFieldValue("num", nextNum - plusNum);
      } else {
        setRightBox([true, data[nextNum - plusNum]]);
        rightFormRef.current.resetFields();
        rightFormRef.current.setFieldsValue(data[nextNum - plusNum]);
      }
    }
  };

  const wordDeleteHandler = () => {

    const instance = JSON.parse(JSON.stringify(wordData))
    for(let i=instance.length-1; i>=0; i--) {
      if(selectedKeys.indexOf(instance[i].id) !== -1){
        instance.splice(i,1)
        continue;
      }
    }
    const source = instance.map((el,idx)=>{
      el.num = idx
      return el
    })
    setWordData(source)
  }


  useEffect(() => {
    setLoading(true);
    const { current, pageSize } = tableParams.pagination;
    const sorterCol = tableParams.sorter?.column?.dataIndex || "id"
    const sorterDirection = tableParams.sorter?.order === "ascend" ? "ASC" : "DESC"

    axios
      .post(`${backend}/contents/word/list?current=${current}&pageSize=${pageSize}&sorterCol=${sorterCol}&sorterDirection=${sorterDirection}`,
      {filter:tableParams.filters})
      .then((data) => {
        getSourceData(data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        if (err.response.status === 401) {
          dispatch(authAction(false, null));
        }
      });
  }, 
  [
    JSON.stringify(tableParams.filters),
    JSON.stringify(tableParams.pagination.current),
    JSON.stringify(tableParams.pagination.pageSize),
    JSON.stringify(tableParams.sorter),
    reRender
  ]);

  useEffect(()=>{
    if(rightBox[0]) {

      const SystemSettingLanguage_code = tableParams.filters.language
      const sorterCol = wordTableParams.sorter?.column?.dataIndex || "id"
      const sorterDirection = wordTableParams.sorter?.order === "descend" ? "DESC" : "ASC"

      const id = rightBox[1].id
      axios
        .get(`${backend}/contents/word/${id}?SystemSettingLanguage_code=${SystemSettingLanguage_code}&sorterCol=${sorterCol}&sorterDirection=${sorterDirection}`)
        .then(res=>{
          getWordData(res)
          setLoading(false)
        })
        .catch(err=>{
          console.log(err)
          setLoading(false)
        })
    }
  },[rightBox[1].num, JSON.stringify(wordTableParams),rightBoxRerender])

//   useEffect(() => {
//     if (rightBox[0]) {
//       const num = rightFormRef.current.getFieldValue("num");
//       rightFormRef.current.setFieldsValue(sourceDataKor[num]);
//     }
//   }, [sourceDataKor]);

  return (
    <div style={{ display: "flex", flexDirection:"column", height:"100%", overflow: "auto" }}>
       <Modal
        destroyOnClose={true}
        open={insertPopup}
        title="단어 등록"
        maskClosable={false}
        onCancel={() => setInsertPopup(false)}
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                formRef.current.resetFields();
              }}
            >
              내용 초기화
            </Button>
            <span>
              <Button
                type="primary"
                onClick={insertOkHandler}
                icon={<CheckOutlined />}
              >
                등록
              </Button>
              <Button onClick={insertOkNextHandler} icon={<CheckOutlined />}>
                등록 후 계속
              </Button>
              <Button
                onClick={() => setInsertPopup(false)}
                icon={<CloseOutlined />}
              >
                취소
              </Button>
            </span>
          </div>
        }
      >
        <Form
          ref={formRef}
          layout="vertical"
        >
          <Form.Item
            name="word"
            label="단어"
            required={true}
            rules={[{ required: true, message: "단어는 필수값입니다." }]}
          >
            <Input />
          </Form.Item>

          <Form.Item 
            name="cefr"
            label="CEFR Level (여러 개일 경우 가장 낮은 Level 을 선택)"
            required={true}
            rules={[{ required: true, message: "CEFR Level 선택은 필수입니다." }]}
          >
            <Radio.Group  >
              <Space direction="horizontal">
                <Radio value={"A0"}>A0</Radio>
                <Radio value={"A1"}>A1</Radio>
                <Radio value={"A2"}>A2</Radio>
                <Radio value={"B1"}>B1</Radio>
                <Radio value={"B2"}>B2</Radio>
                <Radio value={"C1"}>C1</Radio>
                <Radio value={"C2"}>C2</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            name="derivative"
            label="파생어 (여러 개일 경우 콤바 ‘,’ 로 구분하여 입력)"
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        destroyOnClose={true}
        open={editPopup[0]}
        title="단어 수정"
        maskClosable={false}
        onCancel={() => {setEditPopup([false, {}]);setRowIndex(null)}}
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                formRef.current.resetFields();
              }}
            >
              내용 초기화
            </Button>
            <span>
              <Button
                onClick={preRecord}
                disabled={preNext[0]}
                icon={<LeftOutlined />}
              >
                이전
              </Button>
              <Button
                type="primary"
                onClick={editOkHandler}
                icon={<CheckOutlined />}
              >
                수정
              </Button>
              <Button
                onClick={nextRecord}
                disabled={preNext[1]}
                icon={<RightOutlined />}
              >
                다음
              </Button>
              <Button
                onClick={() => {setEditPopup([false, {}]);setRowIndex(null)}}
                icon={<CloseOutlined />}
              >
                취소
              </Button>
            </span>
          </div>
        }
      >
        <Form
          ref={formRef}
          layout="vertical"
          initialValues={editPopup[1]}
        >
          <Form.Item
            name="id"
            hidden = {true}
          ></Form.Item>
          <Form.Item
            name="word"
            label="단어"
            required={true}
            rules={[{ required: true, message: "단어는 필수값입니다." }]}
          >
            <Input />
          </Form.Item>

          <Form.Item 
            name="cefr"
            label="CEFR Level (여러 개일 경우 가장 낮은 Level 을 선택)"
            required={true}
            rules={[{ required: true, message: "CEFR Level 선택은 필수입니다." }]}
          >
            <Radio.Group  >
              <Space direction="horizontal">
                <Radio value={"A0"}>A0</Radio>
                <Radio value={"A1"}>A1</Radio>
                <Radio value={"A2"}>A2</Radio>
                <Radio value={"B1"}>B1</Radio>
                <Radio value={"B2"}>B2</Radio>
                <Radio value={"C1"}>C1</Radio>
                <Radio value={"C2"}>C2</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            name="derivative"
            label="파생어 (여러 개일 경우 콤바 ‘,’ 로 구분하여 입력)"
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <span style={{ minWidth: "100px", textAlign: "left" }}>단어 목록</span>
        <Space wrap>
          <Input.Search
            placeholder="영어 단어를 입력하세요."
            onSearch={onSearch}
            allowClear={true}
            style={{
              width: 250,
              marginLeft: "5px",
            }}
          />
          <Select
            options={[
              {label:"전체", value:"all"},
              {label:"A0", value:"A0"},
              {label:"A1", value:"A1"},
              {label:"A2", value:"A2"},
              {label:"B1", value:"B1"},
              {label:"B2", value:"B2"},
              {label:"C1", value:"C1"},
              {label:"C2", value:"C2"},
            ]}
            style={{ width: 130, textAlign: "left" }}
            defaultValue="CEFR Level"
            // value={tableParams.filters.languageFilter}
            onChange={cefrFilter}
          ></Select>
          <Button onClick={() => setInsertPopup(true)}>
            <PlusOutlined />
            단어 등록
          </Button>
          <Select
            options={languageList}
            defaultValue={"L0010"}
            onChange={languageFilter}
          ></Select>
        </Space>
      </div>
      <div style={{ display: "flex", height:"100%", width:"100%", overflow: "auto" }}>
       
        <Col flex={1} style={{ minWidth: "100px" }}>
          <StyledTable
            className="pageTable"
            onRow={onRow}
            rowClassName={(record, index) => {
              return index === rowIndex ? "selectedRow" : "";
            }}
            columns={columns}
            rowKey="id"
            dataSource={sourceDataKor}
            loading={loading}
            pagination={tableParams.pagination}
            onChange={handleTableChange}
            scroll={{ x:100, y:"100%"}}
          />
        </Col>

        {rightBox[0] ? (
          <Col
            flex={0}
            style={{
              minWidth: "500px",
              border: "1px whitesmoke solid",
              marginLeft: "10px",
              height: "100%",
              overflow:"auto"
            }}
          >
            <div
              style={{
                padding: "10px",
                borderBottom: "1px whitesmoke solid",
                fontWeight: 700,
                fontSize: 17,
                textAlign: "left",
              }}
            >
              편집
            </div>
            <Layout.Content style={{ padding: "10px" }}>
              <Form
                ref={rightFormRef}
                layout="vertical"
                initialValues={rightBox[1]}
              >
                <Form.Item name="id" label="id" hidden={true}>
                  <Input></Input>
                </Form.Item>
                <Form.Item name="rowKey" label="rowKey" hidden={true}>
                  <Input></Input>
                </Form.Item>
                <Form.Item name="num" label="num" hidden={true}>
                  <Input></Input>
                </Form.Item>
                {/* <Form.Item name="ContentSentenceMaster_id" hidden={true}>
                  <Input></Input>
                </Form.Item> */}
                <Form.Item name="word" label="단어">
                  <Input
                    id="sentence"
                    disabled
                    suffix={<CopyTwoTone onClick={copyToClipboard} style={{cursor:"pointer"}}/>}
                  ></Input>
                </Form.Item>
              </Form>
              <Col flex={1} style={{ minWidth: "100px" }}>
                <StyledTable
                  // className="pageTable"
                  // onRow={onRow}
                  // rowClassName={(record, index) => {
                  //   return index === rowIndex ? "selectedRow" : "";
                  // }}
                  rowSelection={{
                    selectedRowKeys: selectedKeys,
                    onChange: (keys, rows) => {
                      setSelectedRows(rows.sort((a, b) => a.num - b.num));
                      setSelectedKeys(keys.sort((a, b) => a - b));
                    },
                  }}
                  columns={wordColumns}
                  rowKey="id"
                  dataSource={wordData}
                  loading={loading}
                  pagination={false}
                  onChange={handleWordTableChange}
                  scroll={{ x:100, y:"100%"}}
                  footer={() => (
                    <div style={{ textAlign: "left" }}>
                      <Space>
                        <Button
                          onClick={() => {
                            const newNum = wordData.length
                            const randomID = parseInt(Math.random()*-1000000)
                            const instance = JSON.parse(JSON.stringify(wordData))
                            instance.push({
                              ContentSettingPartsOfSpeechMaster_code:"1",
                              SystemSettingLanguage_code:tableParams.filters.language,
                              id:randomID,
                              cefr:"A0",
                              num:newNum,
                              word_id:rightBox[1].id,
                              word_meaning:null
                            })
                            setWordData(instance)
                          }}
                        >
                          <PlusOutlined />
                          의미 추가
                        </Button>
                        <Button onClick={wordDeleteHandler}>
                          <DeleteFilled />
                          선택의미 삭제
                        </Button>
                      </Space>
                  </div>
                )}
                />
              </Col>
            </Layout.Content>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
                borderTop: "1px whitesmoke solid",
              }}
            >
              <Button onClick={resetValueRight}>내용 초기화</Button>
              <span>
                <Button
                  onClick={preRecordRight}
                  disabled={rightBoxPreNext[0] || loading}
                  icon={<LeftOutlined />}
                >
                  이전
                </Button>
                <Button
                  style={{ marginLeft: "5px" }}
                  type="primary"
                  onClick={editOkHandlerRight}
                  disabled={loading || JSON.stringify(wordData) === JSON.stringify(originWordData)}
                  icon={<CheckOutlined />}
                >
                  수정
                </Button>
                <Button
                  style={{ marginLeft: "5px" }}
                  onClick={nextRecordRight}
                  disabled={rightBoxPreNext[1] || loading}
                  icon={<RightOutlined />}
                >
                  다음
                </Button>
                <Button
                  style={{ marginLeft: "5px" }}
                  onClick={editCancelHandlerRight}
                  icon={<CloseOutlined />}
                >
                  취소
                </Button>
              </span>
            </div>
          </Col>
        ) : null}

      </div>
    </div>
  );
}

export default Word;
